var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5393_10788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5393_10788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53193 20.1349L19.0959 30.6984C19.4224 31.0255 19.5873 31.4095 19.5909 31.8505C19.5947 32.2915 19.4336 32.6768 19.1075 33.0064C18.781 33.337 18.3959 33.5004 17.952 33.4965C17.5082 33.4927 17.1217 33.3277 16.7928 33.0016L3.44794 19.6568C3.27321 19.4801 3.14616 19.2964 3.06679 19.1057C2.98711 18.9147 2.94727 18.7121 2.94727 18.498C2.94727 18.2839 2.98711 18.0818 3.06679 17.8917C3.14616 17.7013 3.27321 17.5181 3.44794 17.3421L16.8043 3.98573C17.1419 3.65963 17.5286 3.49658 17.9645 3.49658C18.4001 3.49658 18.781 3.65963 19.1075 3.98573C19.4336 4.31983 19.5966 4.7053 19.5966 5.14212C19.5966 5.57927 19.4336 5.96153 19.1075 6.28891L8.53193 16.864H31.9627C32.4315 16.864 32.8232 17.0192 33.1378 17.3296C33.4524 17.64 33.6096 18.03 33.6096 18.4994C33.6096 18.9689 33.4524 19.3588 33.1378 19.6693C32.8232 19.9797 32.4315 20.1349 31.9627 20.1349H8.53193Z",
    fill: "#030311"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.384158f884989d59a522ae0d833608e0.svg";
export { ForwardRef as ReactComponent };